import * as React from 'react';

import { config } from './pdc-platform/src/ts/config';

export function getSignInFormContent(layoutType: string, title: string, errors, form): React.JSX.Element {
    if (layoutType !== 'narrow') {
        const logoStyle: React.CSSProperties = {};
        if (config.LOGO_IMAGE_WIDTH && config.LOGO_IMAGE_WIDTH.length > 0) {
            logoStyle.width = config.LOGO_IMAGE_WIDTH;
        }
        if (config.LOGO_IMAGE_HEIGHT && config.LOGO_IMAGE_HEIGHT.length > 0) {
            logoStyle.height = config.LOGO_IMAGE_HEIGHT;
        }

        const formStyle: React.CSSProperties = {
            background: 'white',
            position: 'absolute',
            borderRadius: '5px'
        };

        if (config.LOGIN_FORM_HEIGHT && config.LOGIN_FORM_HEIGHT.length > 0) {
            formStyle.height = config.LOGIN_FORM_HEIGHT;
        }

        if (config.LOGIN_FORM_WIDTH && config.LOGIN_FORM_WIDTH.length > 0) {
            formStyle.width = config.LOGIN_FORM_WIDTH;
        }

        if (config.LOGIN_FORM_TOP && config.LOGIN_FORM_TOP.length > 0) {
            formStyle.top = config.LOGIN_FORM_TOP;
        }

        if (config.LOGIN_FORM_RIGHT && config.LOGIN_FORM_RIGHT.length > 0) {
            formStyle.right = config.LOGIN_FORM_RIGHT;
        }

        if (config.LOGIN_FORM_LEFT && config.LOGIN_FORM_LEFT.length > 0) {
            formStyle.left = config.LOGIN_FORM_LEFT;
        }

        return (
            <div className="popup-sign-in">
                <h1></h1>
                <div
                    style={{
                        backgroundImage: "url('" + config.LOGIN_FORM_BACKGROUND_IMAGE_URL + "')",
                        backgroundSize: 'cover',
                        position: 'absolute',
                        top: '5%',
                        bottom: '10%',
                        left: '0px',
                        right: '0px'
                    }}
                >
                    <div style={formStyle}>
                        <table
                            style={{
                                marginTop: '56px',
                                marginLeft: '48px',
                                marginRight: '48px'
                            }}
                        >
                            <tbody>
                                <tr>
                                    <td style={{ padding: '1rem' }}>
                                        <img src={config.LOGO_IMAGE_URL} style={logoStyle} />
                                    </td>
                                    <td style={{ padding: '1rem' }}>
                                        <h3>{config.LOGO_APP_TITLE}</h3>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>{form}</td>
                                </tr>
                                {errors != null ? (
                                    <tr>
                                        <td colSpan={2}>{errors}</td>
                                    </tr>
                                ) : null}
                            </tbody>
                        </table>
                        <div
                            style={{
                                position: 'absolute',
                                bottom: '24px',
                                width: '100%',
                                textAlign: 'center'
                            }}
                        >
                            <span>In case of problems&nbsp;</span>
                            <a href={config.CONTACT_VENDOR_URL} target="_blank">
                                {config.CONTACT_VENDOR}
                            </a>
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        position: 'fixed',
                        top: '1rem',
                        right: '1rem'
                    }}
                >
                    <a href={config.PRIVACY_POLICY_URL} target="_blank">
                        Privacy and Cookie Policy
                    </a>
                </div>
            </div>
        );
    } else {
        return (
            <div
                style={{
                    background: 'white',
                    position: 'absolute',
                    width: window.screen.width,
                    height: window.screen.height
                }}
            >
                <table
                    style={{
                        marginLeft: '16px',
                        marginRight: '16px',
                        width: window.screen.width - 40
                    }}
                >
                    <tbody>
                        <tr>
                            <td style={{ padding: '1rem' }}>
                                <img src="./assets/PDC Logo.png" style={{ width: '120px' }} />
                            </td>
                            <td style={{ padding: '1rem' }}>
                                <h4>{config.LOGO_APP_TITLE}</h4>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>{form}</td>
                        </tr>
                        {errors != null ? (
                            <tr>
                                <td colSpan={2}>{errors}</td>
                            </tr>
                        ) : null}
                    </tbody>
                </table>
                <div
                    style={{
                        position: 'absolute',
                        bottom: '24px',
                        width: '100%',
                        textAlign: 'center'
                    }}
                >
                    <span>In case of problems&nbsp;</span>
                    <a href="https://www.pdc.com/contact/">contact PDC</a>
                </div>
            </div>
        );
    }
}

export function getSignInFormElementStyles(): {
    labelStyle: React.CSSProperties;
    fieldStyle: React.CSSProperties;
    buttonStyle: React.CSSProperties;
    linkStyle: React.CSSProperties;
    leftLinkStyle: React.CSSProperties;
} {
    return {
        labelStyle: {
            display: 'none'
        },
        fieldStyle: {
            width: '100%',
            fontSize: '14px',
            marginBottom: '16px',
            height: '40px'
        },
        buttonStyle: {
            width: '100%',
            fontSize: '14px',
            height: '40px'
        },
        linkStyle: {
            textAlign: 'center',
            marginTop: '16px',
            marginBottom: '16px'
        },
        leftLinkStyle: {
            textAlign: 'left',
            marginTop: '16px',
            marginBottom: '16px'
        }
    };
}

export function getSignInFormElementClasses(): {
    labelClass: string;
    fieldClass: string;
    fieldOffsetClass: string;
} {
    return {
        labelClass: '',
        fieldClass: 'col-sm-12',
        fieldOffsetClass: 'col-sm-12'
    };
}
